import axios from 'axios';
import authHeader from './auth-header';
import moment from "moment";

const API_URL = process.env.VUE_APP_BASE_URL + '/matches/';

class MatchDataService {
    getAllMatchesWithUserTips(data) {
        return axios.post(
            API_URL + data.day,
            {
                maintenanceUser: data.maintenanceUser,
                seasonYear: data.seasonYear
            },
            {headers: authHeader()}
        );
    }

    getAllMatches(data) {
        return axios.get(
            API_URL + "all/" + data.season + "/" + data.day,
            {headers: authHeader()}
        );
    }

    getMatch(id) {
        return axios.get(
            API_URL + 'find/' + id,
            {headers: authHeader()}
        );
    }

    saveMatch(match) {
        return axios.post(
            API_URL + 'save/' + match._id,
            {match},
            {headers: authHeader()}
        );
    }

    formatDate(date) {
        return moment.utc(date).local().locale('de').calendar();
    }

    initMatchDay(data) {
        return axios.post(
            API_URL + "init/",
            {
                matchDayNumber: data.dayNumber,
                seasonYear: data.seasonYear
            },
            {headers: authHeader()}
        )
    }

    updateMatchDayByApi(data) {
        return axios.post(
            API_URL + "update-by-api/",
            {
                matchDayNumber: data.dayNumber,
                season: data.season
            },
            {headers: authHeader()}
        )
    }

    saveTip(matchTip) {
        return axios.post(API_URL + "tip/save/",
            {
                _id: matchTip._id,
                match_id: matchTip.match_id,
                homeScore: matchTip.homeScore,
                guestScore: matchTip.guestScore,
                maintenanceUser: matchTip.maintenanceUser
            },
            {headers: authHeader()}
        )
    }
}

export default new MatchDataService();